import axios from "axios";
import { getConfigHeader, URL_FORGOT_PASSWORD } from "./config";

const send = async (user) => {
  const formData = new FormData();
  formData.append("login", user.login);
  formData.append("email", user.email);

  return axios.post(URL_FORGOT_PASSWORD, formData, getConfigHeader());
};

export { send };
